var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseCompletePage',{attrs:{"content":_vm.getCover,"sdnData":_vm.SDN_TEMPLATE,"sdnDataAdvised":_vm.SDN_TEMPLATE_ADVISED}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }